import './AvatarGroup.css';
export var additionalAvatarWrapper = '_129un530-3-8-0';
export var avatarGroupItemWrapper = '_129un531-3-8-0';